import { useNavigate, useSearchParams } from "react-router-dom";

import { useIdentityClient } from "../../hooks";
import type { AuthenticationRequestData } from "../../schemas";

import { PasswordResetTemplate } from "./password-reset.template";

export const PasswordReset = () => {
	const [searchParams] = useSearchParams();
	const username = searchParams.get("username");
	const navigate = useNavigate();
	const { client } = useIdentityClient();

	const handleSubmit = (data: AuthenticationRequestData) => {
		client.initiatePasswordReset({ email: data.username });
		navigate(`/password-reset-verify?username=${encodeURIComponent(data.username)}`);
	};

	return <PasswordResetTemplate onSubmit={handleSubmit} defaultUsername={username || ""} isError={false} />;
};
